<router-outlet></router-outlet>
<p-toast
  [breakpoints]="{ '768px': { width: '95%', right: '2.5%', left: '2.5%' } }"
  position="top-right"
></p-toast>
<p-toast
  key="alarm"
  [breakpoints]="{ '768px': { width: '95%', right: '2.5%', left: '2.5%' } }"
  position="top-center"
></p-toast>
<p-confirmDialog
  [breakpoints]="{ '768px': { width: '95vw' }, '1024px': { width: '70vw' } }"
  [style]="{ width: '50vw' }"
  [autofocus]="false"
></p-confirmDialog>
